"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeownerController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require("angular-ui-router");

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _homeowner = require("./homeowner.routes");

var _homeowner2 = _interopRequireDefault(_homeowner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = require("debug")("fifi:homeowner");

var HomeownerController = exports.HomeownerController = function () {
  /*@ngInject*/
  function HomeownerController(Applications, $state, Auth, $stateParams) {
    _classCallCheck(this, HomeownerController);

    debug("test");
    this._Applications = Applications;
    this._$state = $state;
    this._$stateParams = $stateParams;
    this.resetForm();
    debug(this.settings);
    if (!this.settings.enableOBHOForm && !Auth.isAdminSync()) {
      $state.go("main");
    }
    if ($stateParams.type && $stateParams.type == "OB HO") {
      this.headline = "Ocean Beach";
    }
    if ($stateParams.type && $stateParams.type == "SA HO") {
      this.headline = "Saltaire";
    }
  }

  _createClass(HomeownerController, [{
    key: "submitForm",
    value: function submitForm(form) {
      var _this = this;

      debug(form);
      if (form.$valid) {
        var part1 = this.idPart1.replace(/ /g, "").toLowerCase();
        var part2 = this.idPart2.replace(/ /g, "").toLowerCase();
        var part3 = this.idPart3.replace(/ /g, "").toLowerCase();
        var id = part1 + "-" + part2 + "-" + part3;
        debug(id);
        this._Applications.homeowner({ id: id, zip: this.zip, type: this._$stateParams.type }).then(function (response) {
          debug(response);
          _this.application = response;
          _this.application.obOverride = true;
          _this.application.history.push({
            sticker: _this.application.sticker,
            year: _this.application.year,
            notes: _this.application.notes,
            status: _this.application.sticker,
            payment: _this.application.payment,
            charge: _this.application.charge
          });
          Reflect.deleteProperty(_this.application, "sticker");
          Reflect.deleteProperty(_this.application, "_id");
          Reflect.deleteProperty(_this.application, "year");
          Reflect.deleteProperty(_this.application, "status");
          Reflect.deleteProperty(_this.application, "charge");
          Reflect.deleteProperty(_this.application, "payment");
          Reflect.deleteProperty(_this.application, "agreement");
          Reflect.deleteProperty(_this.application, "timestamp");
          Reflect.deleteProperty(_this.application, "__v");
          Reflect.deleteProperty(_this.application, "active");
          _this.application.failedAttempts = 0;
          debug(_this.application);
        }, function (err) {
          console.log(err);
          _this.error = err.data.message;
          if (!err.data.message) {
            _this.error = "Please check all information and try again.";
          }
        });
      }
    }
  }, {
    key: "beginApplication",
    value: function beginApplication() {
      if (this.application.homeownerId) {
        this._$state.go("application.contact", {
          homeownerApp: this.application
        });
      } else {
        this.resetForm();
        this.error = "The application is invalid, please try again or contact us at 631-665-3600";
      }
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.application = null;
      this.error = null;
      this.idPart1 = null;
      this.idPart2 = null;
      this.idPart3 = null;
      this.zip = null;
    }
  }]);

  return HomeownerController;
}();

exports.default = _angular2.default.module("parkingFormApp.homeowner", [_angularUiRouter2.default]).config(_homeowner2.default).component("homeowner", {
  template: require("./homeowner.html"),
  controller: HomeownerController,
  controllerAs: "$homeowner",
  bindings: {
    settings: "<"
  }
}).name;


// WEBPACK FOOTER //
// ./client/app/homeowner/homeowner.component.js